import React, { Component } from "react"
import { connect } from "react-redux"
import { bindActionCreators, compose } from "redux"
import { isEmpty } from "lodash"

import InputField from "components/input"
import SubmitNotification from "components/common/submit-notification"
import { AUTH_TYPES, AUTH_SUCCESS } from "constants/auth-types"

import { validateEmail } from "helpers/regex-validator"

import { forgotPassword, showAuthModal } from "store/auth/action"

import { GOOGLE_SITE_KEY } from "constants/config"

import "styles/components/auth/auth.scss"
import Button from "../common/Button"

export class ForgotPassword extends Component {
  constructor() {
    super()

    this.state = {
      forgotPasswordForm: {
        email: "",
      },
      fieldErrors: {},
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      auth: { errors },
    } = this.props

    const {
      auth: { errors: prevErrors },
    } = prevProps

    if (errors !== prevErrors) {
      this.setState({ fieldErrors: errors })
    }
  }

  handleChange = (e) => {
    const { forgotPasswordForm } = this.state
    const { name, value } = e.currentTarget

    this.setState(
      {
        forgotPasswordForm: {
          ...forgotPasswordForm,
          [name]: value,
        },
      },
      () => {
        this.validateField(name)
      }
    )
  }

  validateField = (fieldName) => {
    let fieldErrors = this.state.fieldErrors

    if (isEmpty(fieldErrors[fieldName])) {
      fieldErrors.fieldName = "This field is required"
    } else {
      delete fieldErrors[fieldName]
    }
    this.setState({ fieldErrors })
  }

  handleForgotPassword = (e) => {
    e.preventDefault()
    const { forgotPassword } = this.props
    const { forgotPasswordForm } = this.state

    const { error } = this.validateOnSubmit(forgotPasswordForm)
    if (!isEmpty(error)) {
      this.setState({ fieldErrors: error })
    } else {
      window.grecaptcha.ready(() => {
        window.grecaptcha
          .execute(GOOGLE_SITE_KEY, { action: "submit" })
          .then((token) => {
            forgotPasswordForm["g-recaptcha-response"] = token

            forgotPassword(forgotPasswordForm)
          })
      })
    }
  }
  validateOnSubmit(values) {
    const error = {}
    if (!values.email) {
      error.email = "Email Address is required"
    } else if (!validateEmail(values.email)) {
      error.email = "Invalid Email Address"
    }

    return { error }
  }

  render() {
    const { forgotPasswordForm, fieldErrors } = this.state

    const {
      auth: { isLoading, authModal, errors },
      showAuthModal,
    } = this.props

    return (
      <>
        {authModal.successType === AUTH_SUCCESS.FORGOT_PASSWORD ? (
          <div className="login-details">
            <h1 className="title">Email Confirmation</h1>
            <h3 className="subtitle">
              You're almost there! To reset your password please check the email
              we've sent to {forgotPasswordForm.email}
            </h3>
          </div>
        ) : (
          <form className="login-details" onSubmit={this.handleForgotPassword}>
            <h1 className="title">Forgot Password</h1>
            <h3 className="subtitle">
              Enter your email address associated with your account and we’ll
              send you a link to reset your password.
            </h3>

            <SubmitNotification
              type={errors && errors.error && "FAILED"}
              message={errors && errors.error}
            />

            <InputField
              label="Email"
              name="email"
              required={true}
              value={forgotPasswordForm["email"]}
              error={fieldErrors["email"]}
              onChange={this.handleChange}
            />
            <Button
              label="Send"
              block
              size="medium"
              type="submit"
              loading={isLoading}
              customClassName={"auth-button"}
            />
          </form>
        )}
        <div className="meta-links">
          <p
            className="link"
            onClick={() => showAuthModal({ type: AUTH_TYPES.LOGIN })}
          >
            Remembered your password?
          </p>
        </div>
      </>
    )
  }
}

const mapStateToProps = (state) => ({
  auth: state.authReducer,
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      forgotPassword,
      showAuthModal,
    },
    dispatch
  )

export default compose(connect(mapStateToProps, mapDispatchToProps))(
  ForgotPassword
)
